/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/function-component-definition */
/// Version of NumberField component compatible with binder (../../utilities/binder.ts)
import React from 'react';
import { NumberField, INumberFieldProps } from './number-field';

type OutputType = number | undefined;
export type INumericFieldProps = Omit<INumberFieldProps, 'onChange'> & { onChange?: (event: OutputType) => void };

export const NumericField = (props: INumericFieldProps) => {
  const { onChange, ...otherProps } = props;
  const internalOnBlur = (values: React.FocusEvent<HTMLInputElement>) => {
    let val = values.target.value;
    if (props.thousandSeparator && props.thousandSeparator !== '') {
      val = val.replace(props.thousandSeparator, '');
    }

    if (props.decimalSeparator && props.decimalSeparator !== '') {
      val = val.replace(props.decimalSeparator, '.');
    }

    const number = parseFloat(val);
    const value = Number.isNaN(number) ? undefined : number;
    onChange && onChange(value);
  };
  return <NumberField onBlur={internalOnBlur} {...otherProps} />;
};
